import { render, staticRenderFns } from "./LayoutConfig.vue?vue&type=template&id=603fdd8f&scoped=true"
import script from "./LayoutConfig.vue?vue&type=script&lang=js"
export * from "./LayoutConfig.vue?vue&type=script&lang=js"
import style0 from "./LayoutConfig.vue?vue&type=style&index=0&id=603fdd8f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "603fdd8f",
  null
  
)

export default component.exports